import { constant } from "common/constant";
import * as yup from "yup";

export const DepartmentSchema = yup.object({
  name: yup.string().required(constant.requiredName),
  description: yup.string()
});
